import React from 'react'
import classNames from 'classnames'
import Span from '@component/Text/Span'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    values?: [string, string]
    toggleClassName?: string
    onChangeValue?: () => void
}

const WizTextSwitch = ({
    checked,
    disabled,
    className,
    toggleClassName,
    onChangeValue,
    values,
    ...props
}: InputProps) => {
    return (
        <label className="relative inline-flex cursor-pointer items-center" onClick={onChangeValue}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                className="peer appearance-none sr-only"
                readOnly
                {...props}
            />
            <div
                className={classNames(
                    'peer flex items-center justify-between gap-[3px] rounded-[5px] p-[3px] bg-gray07 dark:bg-dark_gray07 text-body3 text-gray04 dark:text-dark_gray04',
                    'after:absolute after:py-[3px] after:px-[10px] after:rounded-[5px] after:bg-white after:dark:bg-[#525253] after:text-body3 after:text-gray01 after:dark:text-dark_gray01 after:text-center after:translate-x-0 after:transition-transform',
                    'peer-checked:after:translate-x-full',
                    toggleClassName,
                )}>
                <Span className={'text-body3 w-full text-center py-[3px] px-[10px]'}>{values?.at(0)}</Span>
                <Span className={'text-body3 w-full text-center py-[3px] px-[10px]'}>{values?.at(1)}</Span>
            </div>
        </label>
    )
}
export default WizTextSwitch
